export const ProductFeedbackQuestionIds = {
  sentiment: 'appLossSentiment',
  isRecommended: 'isRecommended',
  recommendReason: 'recommendReason',
  suggestions: 'suggestions',
  followUpEmail: 'allowFollowUp',
} as const;
